import ownerRezLogo from './images/ownerRezLogo.png';
import touchStayLogo from './images/touchStayLogo.png';
import ensoConnectLogo from './images/ensoConnectLogo.svg';
import stayFiLogo from './images/stayFiLogo.png';
import hospitableLogo from './images/hospitableLogo.svg';
import airbnbLogo from './images/airbnbLogo.png';
import guestyLogo from './images/guestyLogo.svg';
import guestyLiteDarkLogo from './images/GuestyLiteDarkLogo.png';
import lodgifyLogo from './images/lodgifyLogo.png';
import hostawayLogo from './images/HostawayLogo.png';
import turnoLogo from './images/turnoLogo.svg';
import hostfullyLogo from './images/hostfullyLogo.svg';
import hosttoolsLogo from './images/hosttoolsLogo.svg';
import React from 'react';
import { IS_STAGING } from 'consts';

import {
  hospitableConnectApi,
  ownerRezApi,
  hospitableApi,
  turnoApi,
  hostfullyApi,
} from 'api/partners';

import { reverse } from 'utils/urls';
import { URLS } from 'components/Routes/urls';
import { IntegrationType } from 'api/types/partners';

export const partnersData = {
  ownerrez: {
    name: IntegrationType.OWNERREZ,
    title: 'Get Started',
    copy: 'Learn how to import your OwnerRez properties with this video.',
    videos: [
      {
        id: 'ybfx0yxKMbM',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue to connect your OwnerRez account.',
      '2) Choose which properties you’d like to create stores for, or create one store from your listings and later duplicate it to your liking.',
      '3) Add or edit products - don’t forget to update your descriptions!',
      '4) One finished, add your store link in your OwnerRez automated messages with custom code {PXHOSTCO}. We recommend sharing your store link at booking, a week before check-in, and at check-in.',
    ],
    onContinue: () => ownerRezApi.authenticate(),
  },
  hospitableconnect: {
    name: IntegrationType.HOSPITABLE_CONNECT,
    title: 'Get Started',
    copy: 'Learn how to import your Airbnb listings with this video.',
    heading: 'Next steps...',
    videos: [
      {
        id: 's3nJDVreGPY',
        title: 'How it Works',
      },
    ],
    instructions: [
      '1) Click continue below to connect your Airbnb account to The Host Co. using Hospitable Connect.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
    ],
    onContinue: () => hospitableConnectApi.authenticate(),
  },
  hospitable: {
    name: IntegrationType.HOSPITABLE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hospitable account with this video.',
    videos: [
      {
        id: 'pAdyEKL_lR8',
        title: 'How it Works',
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue below to connect your Hospitable account to The Host Co.',
      '2) Choose which properties you want to create stores for.',
      '3) Add products to your new stores and start making money!',
    ],
    onContinue: () => hospitableApi.authenticate(),
  },
  guesty: {
    name: IntegrationType.GUESTY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue below to connect your Guesty account.',
      '2) You’ll be asked for a Guesty integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Each store link is pre-populated in Guesty and can be added to your outgoing messages by hitting "+Add variable" and selecting "HostCo".',
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY.toLowerCase() },
      }),
  },
  guesty_lite: {
    name: IntegrationType.GUESTY_LITE,
    title: 'Get Started',
    copy: 'Learn how to connect to your Guesty Lite account with this video.',
    videos: [
      {
        id: 'Aqkjvi-VmTM',
        title: 'How it Works',
        start: 84,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue below to connect your Guesty Lite account.',
      '2) You’ll be asked for a Guesty Lite integration token. If you don’t have a token we’ll show you where to generate one.',
      '3) Paste your integration token into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Copy your store links in the Host Co and paste them in your outgoing Guesty Lite automated messages.',
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.GUESTY_LITE.toLowerCase() },
      }),
  },
  hostaway: {
    name: IntegrationType.HOSTAWAY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Hostaway account with this video.',
    videos: [
      {
        id: 'rQzmDEzT8Zs',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue below to connect your Hostaway account.',
      '2) You’ll be asked for a Hostaway client ID and API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your credentials into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Add your store links in your outgoing Hostaway messages by hitting "+Add Variable" and selecting "listing_hostco".',
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.HOSTAWAY.toLowerCase() },
      }),
  },
  lodgify: {
    name: IntegrationType.LODGIFY,
    title: 'Get Started',
    copy: 'Learn how to connect to your Lodgify account with this video.',
    videos: [
      {
        id: 'DpmexJ4NZ9M',
        title: 'How it Works',
        start: 85,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click continue below to connect your Lodgify account.',
      '2) You’ll be asked for a Lodgify API key. We’ll show you where to get credentials if you don’t have them.',
      '3) Paste your API key into the provided form (required only once).',
      '4) Choose which properties you’d like to create stores for and modify stores to your liking.',
      '5) Share your Host Co store links in your outgoing Lodgify messages.',
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.LODGIFY.toLowerCase() },
      }),
  },
  turno: {
    name: IntegrationType.TURNO,
    title: 'Get Started',
    copy: 'Learn how to import your Turno properties with this video.',
    videos: [
      {
        id: '2Jl6ErmIgXI',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click Connect and your Turno properties will start importing to The Host Co.',
      '2) On the next screen, choose whether to create new stores or link existing Host Co stores to the right Turno properties.',
      '3) Your new stores will auto-fill with optional alterations (like early check-in/late check-out) and popular local services.',
      '4) Once a guest books an early check-in or late check-out and it’s approved, your Turno calendar updates automatically — no manual edits needed.',
      '* For existing Host Co users: you can link your imported Turno properties with existing stores on the next page.',
    ],
    onContinue: () => turnoApi.authenticate(),
  },
  hostfully: {
    name: IntegrationType.HOSTFULLY,
    title: 'Get Started',
    copy: 'Learn how to import your Hostfully properties with this video.',
    videos: [
      {
        id: 'Rq_sYjCiIr0',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      '1) Click “continue” below to initiate the integration. On the following page, click “allow” to connect The Host Co to Hostfully.',
      <>
        <div>
          2) Once the integration has been allowed, click on the
          <a
            href={`https://platform.hostfully.com/app/#/integrations`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px', marginRight: '5px' }}
          >
            Hostfully Integrations Page
          </a>
          (make sure you are logged in).
        </div>
      </>,
      '3) On the integrations page, search for Host Co and toggle the integration ON. Then, open Settings and enable each property you want to connect to The Host Co.',
      '4) Return to The Host Co and navigate back to Partners → Hostfully  →  Start now (this will bring you back to this instruction page with the video). Click “continue” to import your Hostfully properties into The Host Co.',
      '5) Choose whether to create new stores, link existing Host Co stores to Hostfully properties, or skip any properties you don’t want to connect. You can always come back and add more stores later.',
      'Recommended: The Host Co early check-in and late check-out tile will automatically modify your Hostfully calendar times, but if you’d like to create a visual blue dot to indicate early check-ins and late check-outs on your Hostfully calendar:',
      'I) Under Agency Settings, create a Service provider named The Host Co.',
      'II) Add two Services: early check-in and late check-out. Note: The service provider name (The Host Co) and service names must be spelled correctly to trigger the blue dots.',
      <>
        <div>
          If your Host Co stores were created before May 14, 2025: your Early Check-In and Late
          Check-Out tiles will not sync with Hostfully’s calendar, as these older tiles do not
          include the new required time fields. To fix this, you’ll need to replace your old tiles
          with the updated versions.
          <a
            href={`https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations`}
            target="_blank"
            rel="noreferrer"
            style={{ marginLeft: '5px' }}
          >
            Click here to learn more
          </a>
          .
        </div>
      </>,
    ],
    onContinue: () => hostfullyApi.authenticate(),
  },
};

if (IS_STAGING) {
  partnersData.hosttools = {
    name: IntegrationType.HOST_TOOLS,
    title: 'Get Started',
    copy: 'Learn how to import your Host Tools properties with this video.',
    videos: [
      {
        id: '',
        title: 'How it Works',
        start: 86,
      },
    ],
    heading: 'Next steps...',
    instructions: [
      <div key="1" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <ol style={{ paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <li>
            Click <strong>continue</strong> to connect your Host Tools account.
          </li>
          <li>
            You’ll be asked for a HostTools integration token. If you don’t already have one, click{' '}
            <strong>API & Integrations</strong>. You’ll be taken to the HostTools integrations
            page—select <strong>The Host Co</strong> and copy your integration token.
          </li>
          <li>
            On The Host Co site, paste your integration token into the provided form (this is only
            required once).
          </li>
          <li>
            Choose how you’d like to connect your properties:
            <ul>
              <li>
                Create new Host Co stores. This creates a Host Co store for each of your HostTools
                listings.{' '}
              </li>
              <li>Link existing Host Co stores to HostTools properties</li>
              <li>
                Or skip any properties you don’t want to connect (you can always add more later)
              </li>
            </ul>
          </li>
          <li>
            Each Host Co store link automatically syncs with HostTools. Add it to your automated
            guest messages using the message tag <pre>{'{{Upsell URL}}'}</pre> to share the correct
            store with each guest.
          </li>
          <li>
            We recommend sharing your store:
            <ul>
              <li>In your “Thanks for booking” message</li>
              <li>One week before check-in</li>
              <li>In your check-in notes</li>
              <li>For message templates, click Share on any Host Co store.</li>
            </ul>
          </li>
        </ol>

        <strong>Note on Early Check-In & Late Check-Out</strong>
        <p>
          The Host Co Early Check-In and Late Check-Out tiles can automatically update your
          HostTools booking times (with your approval),{' '}
          <strong>unless your Host Co stores were created before May 14, 2025.</strong>
        </p>
        <p>
          If your stores were created before this date, these tiles will not sync with the HostTools
          calendar because older versions don’t include the required time fields.
        </p>
        <p>
          <strong>To fix this: </strong>
          replace your old tiles with the updated versions.
        </p>
        <p>
          <a href="https://www.youtube.com/watch?v=vMtt_rK4Sggtform.hostfully.com/app/#/integrations">
            Click here to learn more.
          </a>
        </p>
      </div>,
    ],
    onContinue: () =>
      reverse({
        url: URLS.INTEGRATION,
        params: { company: IntegrationType.HOST_TOOLS.replace(' ', '').toLowerCase() },
      }),
  };
}

export const listPartners = [
  {
    key: 'Ownerrez',
    image: ownerRezLogo,
    description: 'Automatically create stores for your OwnerRez properties.',
    action: (history) => {
      history.push('/overview/partners/landing/ownerrez');
    },
  },
  {
    key: 'TouchStay',
    image: touchStayLogo,
    description: 'Add a Host Co store to your Touch Stay Digital Guide Book.',
    action: () => {
      window.open('https://www.thehost.co/touch-stay', '_blank');
    },
  },
  {
    key: 'Enso Connect',
    image: ensoConnectLogo,
    description: 'Add a Host Co store to your Enso Connect boarding pass.',
    action: () => {
      window.open('https://www.thehost.co/enso-connect', '_blank');
    },
  },
  {
    key: 'StayFi',
    image: stayFiLogo,
    description: 'Send guests to your Host Co Store after they log in to your StayFi Wi-Fi.',
    action: () => {
      window.open('https://www.thehost.co/stayfi', '_blank');
    },
  },
  {
    key: 'Hospitable',
    image: hospitableLogo,
    description: 'Automatically create stores for your Hospitable properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hospitable/');
    },
  },
  {
    key: 'Airbnb',
    image: airbnbLogo,
    description:
      'Automatically create stores for all of your Airbnb properties. Partnership provided by Hospitable Connect.',
    action: (history) => {
      history.push('/overview/partners/landing/hospitableconnect/');
    },
  },
  {
    key: 'Guesty',
    image: guestyLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/partners/landing/guesty/');
    },
  },
  {
    key: 'Guesty Lite',
    image: guestyLiteDarkLogo,
    description: 'Automatically create stores for your Guesty properties.',
    action: (history) => {
      history.push('/overview/partners/landing/guesty_lite/');
    },
  },
  {
    key: 'Hostaway',
    image: hostawayLogo,
    description: 'Automatically create stores for your Hostaway properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hostaway/');
    },
  },

  {
    key: 'Lodgify',
    image: lodgifyLogo,
    description: 'Automatically create stores for your Lodgify properties.',
    action: (history) => {
      history.push('/overview/partners/landing/lodgify/');
    },
  },
  {
    key: IntegrationType.TURNO,
    image: turnoLogo,
    description: 'Automatically create stores for your Turno properties.',
    action: (history) => {
      history.push('/overview/partners/landing/turno/');
    },
  },
  {
    key: IntegrationType.HOSTFULLY,
    image: hostfullyLogo,
    description: 'Automatically create stores for your Hostfully properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hostfully/');
    },
  },
  {
    key: IntegrationType.HOST_TOOLS,
    image: hosttoolsLogo,
    description: 'Automatically create stores for your Host Tools properties.',
    action: (history) => {
      history.push('/overview/partners/landing/hosttools/');
    },
  },
];
